import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class LikeService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  like(like: boolean, content_type_id: number, object_id: number): any {
    this.logger.info('like | like: ' + like)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const data = {
      like: like,
      content_type_id: content_type_id,
      object_id: object_id,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.LIKES}`, data, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('like | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }
}
